var Handlebars = require("../../../node_modules/handlebars/runtime.js");
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<div role=\"alert\" tabindex=\"0\" id=\"displaymax-required-error\" class=\"alert alert-error\">\n  "
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"required_message") || (depth0 != null ? lookupProperty(depth0,"required_message") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"required_message","hash":{},"data":data,"loc":{"start":{"line":2,"column":2},"end":{"line":2,"column":22}}}) : helper)))
    + "\n</div>\n";
},"useData":true});